<template>
    <section class="page-dashbord-offercode pt-3">
        <div class="container">
            <div class="row">
                <div class="col">
                    <header class="text-right mb-4">
                        <h1 class="font-20">
                            کد تخفیف جدید
                        </h1>
                    </header>
                </div>
            </div>
            <form class="wrapper-form row shadow py-4 mb-5" @submit.prevent="saveOfferCode" data-vv-scope="offerCodeForm">
                <div class="col-md-4  col-12">
                    <div class="group-form ">
                        <input type="text" v-validate="'required'" name="reason" :class="{active:offerCodeForm.reason != ''}" v-model="offerCodeForm.reason">
                        <span class="bar"></span>
                        <label class="font-12">مناسبت</label>
                        <span v-if="errors.has('offerCodeForm.reason')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>
                <div class="col-md-4  col-12">
                    <div class="group-form ">
                        <strong class="text-left ltr d-inline-block holder" v-if="offerCodeForm.code === ''">M-</strong>
                        <input type="text" v-validate="'required'" name="code" :class="{active:offerCodeForm.code != ''}" v-model="offerCodeForm.code">
                        <span class="bar"></span>
                        <label class="font-12">کد تخفیف</label>
                        <span v-if="errors.has('offerCodeForm.code')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>
                <div class="col-md-4  col-12">
                    <date-picker :color="'#28A52D'" v-model="offerCodeForm.exp_date" format="jYYYY/jMM/jDD" element="my-custom-input">
                    </date-picker>

                    <div class="group-form mod-ltr">
                        <input readonly type="text" id="my-custom-input" v-validate="'required'" name="exp_date" :class="{active:offerCodeForm.exp_date != ''}" v-model="offerCodeForm.exp_date">
                        <span class="bar"></span>
                        <label class="font-12">تاریخ انقضاء</label>
                        <span v-if="errors.has('offerCodeForm.exp_date')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>
                <div class="col-md-4  col-12">
                    <div class="group-form ">
                        <input type="text" v-validate="'required'" name="off_capacity" :class="{active:offerCodeForm.off_capacity != ''}" v-model="offerCodeForm.off_capacity">
                        <span class="bar"></span>
                        <label class="font-12">ظرفیت(تعداد نفرات)</label>
                        <span v-if="errors.has('offerCodeForm.off_capacity')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>
                <div class="col-md-4  col-12">
                    <div class="group-form ">
                        <input type="text" v-validate="'required'" name="off_percentage" :class="{active:offerCodeForm.off_percentage != ''}" v-model="offerCodeForm.off_percentage">
                        <span class="bar"></span>
                        <label class="font-12">درصد تخفیف (فقط عدد وارد شود)</label>
                        <span v-if="errors.has('offerCodeForm.off_percentage')" class="is-danger">فیلد نباید خالی باشد</span>
                    </div>
                </div>

                <div class="col-12">
                    <div class="form-action">
                        <button class="font-16 px-5 py-2 bttn-fill bttn bttn-success" v-ripple>
                            ذخیره
                        </button>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col">
                    <header class="text-right mb-4">
                        <h2 class="font-20">
                            لیست کدهای تخفیف
                        </h2>
                    </header>
                </div>
            </div>
            <div class="shadow shadow-sm  mb-5 bg-white" v-if="list.length">
                <b-table stacked="lg" :fields="fieldsItems" :items="list" class="text-center">
                    <template v-slot:cell(reason)="row" >
                        <p class="mb-0" v-if="!row.item.isEdit">{{row.item.reason}}</p>
                        <div class="group-form mb-0" v-if="row.item.isEdit">
                            <input type="text" :class="{active:row.item.reason != ''}" v-model="row.item.reason">
                            <span class="bar"></span>
                        </div>
                    </template>
                    <template v-slot:cell(code)="row">
                        <p class="mb-0" v-if="!row.item.isEdit">{{row.item.code}}</p>
                        <div class="group-form mb-0" v-if="row.item.isEdit">
                            <strong class="text-left ltr d-inline-block holder" v-if="row.item.code === ''">M-</strong>
                            <input type="text" :class="{active:row.item.code != ''}" v-model="row.item.code">
                            <span class="bar"></span>
                        </div>
                    </template>
                    <template v-slot:cell(off_capacity)="row"  >
                        <p class="mb-0" v-if="!row.item.isEdit">{{row.item.off_capacity}}</p>
                        <div class="group-form mb-0" v-if="row.item.isEdit">
                            <input type="text" :class="{active:row.item.off_capacity != ''}" v-model="row.item.off_capacity">
                            <span class="bar"></span>
                        </div>
                    </template>
                    <template v-slot:cell(off_percentage)="row" >
                        <p class="mb-0" v-if="!row.item.isEdit">{{row.item.off_percentage}}</p>
                        <div class="group-form mb-0" v-if="row.item.isEdit">
                            <input type="text" :class="{active:row.item.off_percentage != ''}" v-model="row.item.off_percentage">
                            <span class="bar"></span>
                        </div>
                    </template>
                    <template v-slot:cell(exp_date)="row">
                        <date-picker v-if="row.item.isEdit" :color="'#28A52D'" v-model="row.item.exp_date" format="jYYYY/jMM/jDD" :element="'my-custom-input'+row.index">
                        </date-picker>

                        <p class="mb-0" v-if="!row.item.isEdit">{{row.item.exp_date | date}}</p>
                        <div class="group-form mod-ltr mb-0" v-if="row.item.isEdit">
                            <input type="text" :class="{active:row.item.exp_date != ''}" v-model="row.item.exp_date" :id="'my-custom-input'+row.index">
                            <span class="bar"></span>
                        </div>
                    </template>
                    <template v-slot:cell(action)="row" >
                        <div class="text-center">
                            <button @click="edit(row.item, row.index)" class="font-16 px-5 py-2 bttn-fill bttn bttn-success" v-ripple>
                                {{ row.item.isEdit ? 'ثبت' : 'ویرایش' }}
                            </button>
                        </div>
                    </template>
                </b-table>
            </div>
            <page-number :lengthList="lengthList" v-if="list.length" @callBack="getAllOfferCode" />
        </div>
    </section>
</template>

<script>
export default {
  name: 'page-dashbord-offer-code',
  data () {
    return {
      list: [],
      offerCodeForm: {
        code: '',
        exp_date: '',
        off_capacity: '',
        off_percentage: '',
        reason: ''
      },
      lengthList: 1,
      page: 0,
      fieldsItems: [
        { key: 'code', label: 'کد تخفیف' },
        { key: 'reason', label: 'مناسبت' },
        { key: 'off_capacity', label: 'ظرفیت' },
        { key: 'off_percentage', label: 'درصد' },
        { key: 'exp_date', label: 'تاریخ انقضاء' },
        { key: 'action', label: 'عملیات' }
      ],
      items: [
        { fullname: 'داود اصلانی فکور', actions: '', id: '49' },
        { fullname: 'معین رحیمی', actions: '', id: '48' }
      ]
    }
  },
  computed: {
  },
  mounted () {
    this.getAllOfferCode(this.page)
  },
  methods: {
    async saveOfferCode () {
      let result = await this.$validator.validateAll('offerCodeForm')
      if (!result) {
        this.$root.showWarnMsg({
          message: 'لطفا فرم را تکمیل کنید ... '
        })
        return
      }
      let body = {
        code: 'M-' + this.offerCodeForm.code,
        off_capacity: parseInt(this.offerCodeForm.off_capacity),
        off_percentage: parseInt(this.offerCodeForm.off_percentage),
        reason: this.offerCodeForm.reason,
        exp_date: this.milady(this.offerCodeForm.exp_date)
      }
      let { data } = await axios.post('/offer-code-all/set', body)
      if (data.state !== 200) return
      this.$store.commit('notifications/success', { message: this.$t('message.request.done'), title: '' })
      this.offerCodeForm = {
        code: '',
        off_capacity: '',
        off_percentage: '',
        course: '',
        reason: ''
      }
      this.$validator.reset()
      this.getAllOfferCode(this.page)
    },
    async getAllOfferCode (p) {
      try {
        this.page = p
        let { data } = await axios.post('/offer-code-all/get', { page_num: this.page })
        if (data.state !== 200) return
        if (data.codes.length) {
          this.list = data.codes
          this.list.forEach(e => {
            e.isEdit = false
          })
        }
        this.lengthList = data.codes.length
      } catch (error) {
        console.log(error)
      }
    },
    submitAction (row) {
      //   row.toggleDetails()

    },
    remove (item, index) {
      console.log(item, index)
      this.$store.dispatch('dashboardUsers/remove', { user: item, index })
    },
    async update (item, index) {
      try {
        let body = { ...item }
        delete body.isEdit
        delete body.date
        body.off_capacity = parseInt(body.off_capacity)
        body.off_percentage = parseInt(body.off_percentage)
        if (!body.code.startsWith('M-')) {
          body.code = 'M-' + body.code
        }
        let { data } = await axios.post('/offer-code-all/update', body)
        if (data.state !== 200) {
          this.$root.showErrorMsg({
            message: 'خطا در درخواست ...'
          })
          return
        }
        let a = this.list[index]
        if (!a.code.startsWith('M-')) {
          a.code = 'M-' + a.code
          this.list.splice(index, a)
        }
        this.$root.showInfoMsg({
          message: 'با موفقیت تغییر یافت'
        })
      } catch (error) {
        console.log(error)
      }
    },
    edit (item, index) {
      let a = this.list[index]
      if (!item.isEdit) {
        a.exp_date = this.shamsi(a.exp_date)
      } else {
        a.exp_date = this.milady(a.exp_date)
        this.update(item, index)
      }
      a.isEdit = !item.isEdit
      this.list.splice(index, a)
    }
  }
}
</script>

<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-offercode {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/offers.vue